import React, { useState, useRef, useEffect } from "react";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import useTable from "../../components/useTable";
import { Dimmer } from "../spinner";
import axios from "axios";
import { validaSoloNumero } from "../../util/varios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import CatalogoAgenteTipo2 from "../../catalogos/catalogoAgenteTipo2";
import moment from "moment";
import GuiasMovilizacionWeb from "./gestionarGuiasMovilizacionWeb";

function GenerarGuiasMovilizacion() {
  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: <i style={{ textAlign: "center" }}> CÓDIGO</i>,
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: <i style={{ textAlign: "center" }}> MINA</i>,
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: <i style={{ textAlign: "center" }}> DESDE</i>,
      textAlign: "center",
    },
    {
      id: "4",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: <i style={{ textAlign: "center" }}> HASTA</i>,
      textAlign: "center",
    },
    {
      id: "5",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: <i style={{ textAlign: "center" }}> CANTIDAD</i>,
      textAlign: "center",
    },
    {
      id: "6",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: <i style={{ textAlign: "center" }}> FECHA</i>,
      textAlign: "center",
    },
  ];

  const token = JSON.parse(localStorage.getItem("jwtToken"));
  let op = require("../../../public/modulos/datos");

  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const idagente = JSON.parse(localStorage.getItem("idagente"));
  const usuario = JSON.parse(localStorage.getItem("login"));

  /////variables de referencias
  const txtCantidadTalonarios = useRef();
  const txtIdExpendedor = useRef();

  /////variables de estados
  const [activate, setActivate] = useState(false);
  const [expendedor, setExpendedor] = useState();
  const [inhabilitado, setInhabilitado] = useState(true);
  const [mostrarcatalogo, setMostrarcatalogo] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [planillas, setPlanillas] = useState([]);
  const [records, setRecords] = useState([]);

  const txtBuscador = useRef();

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            if (
              x.idtalonarioguia.includes(target.value) ||
              x.idmina.includes(target.value) ||
              x.nombre.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      },
    });
  };

  const SeleccionarTalonarios = () => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/guia/talonariosgenerados`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          console.log(response.data);
          setRecords(response.data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  /////#####proceso para generar las planillas#####/////
  const procesarRegistro = (body) => {
    setActivate(true);
    let endpoint = "";
    endpoint = `${op.conexion}/api/guia/actualizartalonarios`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.respuesta > 0) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: `${response.data.respuesta} Talonarios Generados Correctamente.`,
              icono: "exito",
            });
            SeleccionarTalonarios();
            blanquearExpendedor();
          }
          setActivate(false);
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };
  /////#####$$$$$#####/////

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  /////#####funcion para generar las planillas#####/////
  const generarTalonarios = () => {
    const element = [];

    for (let i = 0; i < parseInt(txtCantidadTalonarios.current.value); i++) {
      element.push({
        idusuariosistema: idagente,
        fechasistema: fechaSistema,
        idmina: txtIdExpendedor.current.value,
      });
    }

    let body = {
      talonarios: element,
    };

    if (element.length > 0) {
      procesarRegistro(body);
    }
  };
  /////#####$$$$$#####/////

  const blanquearExpendedor = () => {
    setExpendedor();
    txtIdExpendedor.current.value = "";
    txtCantidadTalonarios.current.value = "1";
    setInhabilitado(true);
  };
  /////#####$$$$$#####/////

  /////#####funcion para seleccionar el expendedor desde el catalogo#####/////
  const seleccionarExpendedor = (idage, nombage, status, direcc, nre, nli) => {
    if (status === "52") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "la mina no se encuentra Activa.",
        icono: "informacion",
      });
      txtIdExpendedor.current.value = "";
      blanquearExpendedor();
      setInhabilitado(true);
    } else {
      setExpendedor({
        idagente: idage,
        status: status,
        nombre: nombage,
        direccion: direcc,
        nroresolucion: nre,
        nrolicencia: nli,
      });
      // gestionartimbredetalle(idage);
      txtIdExpendedor.current.value = idage;
      setInhabilitado(false);
    }
  };
  /////#####$$$$$#####/////

  /////#####funcion para abrir el catalogo de expendedores#####/////
  const catalogoExpendedor = () => {
    setMostrarcatalogo(true);
  };
  /////#####$$$$$#####/////

  /////#####funcion para cerrar el catalogo de expendedores#####/////
  const cerrarCatalogo = () => {
    setMostrarcatalogo(false);
  };

  const buscarExpendedor = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        gestionarExpendedor(event.target.value);
      }
    }
  };

  const gestionarExpendedor = (id) => {
    setActivate(true);

    let campos = "*";
    let nomtab = "agente";
    let nomid = "idagente";
    let id2 = true;
    let nomid2 = "mina";
    let orden = "idagente";

    let endpoint = `${op.conexion}/api/consulta/idsstring2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=${id2}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idagente > 0) {
            if (response.data.statusmina === "52") {
              setInhabilitado(true);
              blanquearExpendedor();
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "la mina no se encuentra Activa.",
                icono: "informacion",
              });
            } else {
              setExpendedor(response.data);
              setInhabilitado(false);
              //gestionartimbredetalle(response.data.idagente);
            }
          } else {
            blanquearExpendedor();
            setInhabilitado(true);
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "no existe una mina con ese codigo",
              icono: "informacion",
            });
          }
          setActivate(false);
        }
      })
      .catch(function (error) {
        console.log(error);

        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  useEffect(() => {
    SeleccionarTalonarios();
  }, []);

  return (
    <div className="container-fluid px-3 py-3">
      <ul className="nav mb-3 h-25" id="ex-with-icons" role="tablist">
        <li className="nav-item" role="presentation">
          <a
            className="nav-link text-dark rounded"
            style={{ backgroundColor: "#19D6FF" }}
            id="ex-with-icons-tab-1"
            data-mdb-toggle="tab"
            href="#ex-with-icons-tabs-1"
            role="tab"
            aria-controls="ex-with-icons-tabs-1"
            aria-selected="true"
          >
            <i className="fas fa-chart-pie fa-fw me-2" />
            Asignacion
          </a>
        </li>
        <li className="nav-item" role="presentation">
          <a
            className="nav-link text-dark rounded"
            style={{ backgroundColor: "#F29705" }}
            id="ex-with-icons-tab-2"
            data-mdb-toggle="tab"
            href="#ex-with-icons-tabs-2"
            role="tab"
            aria-controls="ex-with-icons-tabs-2"
            aria-selected="false"
          >
            <i className="fas fa-chart-pie fa-fw me-2" />
            Historico
          </a>
        </li>
      </ul>
      <div className="tab-content" id="ex-with-icons-content">
        <div
          className="tab-pane fade show active"
          id="ex-with-icons-tabs-1"
          role="tabpanel"
          aria-labelledby="ex-with-icons-tab-1"
        >
          <div
            className="col-md-12 row  p-4 justify-content-around"
            style={{
              backgroundColor: "white",
              boxShadow: "0px 0px 10px 1px #aaaaaa",
            }}
          >
            <div className="col-md-5 border-table">
              <p className="h2 text-center">
                <strong>{"INFORMACIÓN DE LA MINA"}</strong>
              </p>
              <div className="mx-4 my-4 was-validated">
                <Dimmer active={activate} />
                <div
                  className="input-group input-group-sm mb-3"
                  style={{ width: 200 }}
                >
                  <label
                    htmlFor="codigo"
                    className="form-label input-group-text"
                    id="validationTooltipCodigo"
                    style={{ backgroundColor: "#55acee" }}
                  >
                    Código:
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    onKeyUp={buscarExpendedor}
                    ref={txtIdExpendedor}
                    name="codigo"
                    aria-describedby="validationTooltipCodigo"
                    placeholder="Código"
                    className="form-control border"
                    required
                  />
                  <button className="btn btn-info" onClick={catalogoExpendedor}>
                    <i className="fa fa-search"></i>
                  </button>
                </div>
                <h4 className="text-primary">
                  <i className="fas fa-user-alt me-2" />
                  Mina: {expendedor && expendedor.nombre}
                </h4>
                <hr className="dropdown-divider" />
                <div className="row">
                  <div className="col-md-12">
                    <ol className="list-unstyled mb-0 pt-0 pb-0">
                      <li className="mb-1">
                        <i className="fas fa-home me-2" />
                        <small>
                          Dirección: {expendedor && expendedor.direccion}{" "}
                        </small>
                      </li>
                      <li className="mb-1">
                        <i className="fas fa-chalkboard-teacher me-2" />
                        <small>
                          N°-Resolución:{" "}
                          {expendedor && expendedor.nroresolucion}{" "}
                        </small>
                      </li>
                      <li className="mb-1">
                        <i className="fas fa-id-badge me-2" />
                        <small>
                          N°-Licencia: {expendedor && expendedor.nrolicencia}
                        </small>
                      </li>
                    </ol>
                  </div>
                  <div className="input-group input-group-sm col-sm-4">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Cantidad Talonarios:
                    </span>
                    <input
                      type="number"
                      min={1}
                      disabled={inhabilitado}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      ref={txtCantidadTalonarios}
                      defaultValue={1}
                    />
                  </div>
                </div>
                <div
                  className="row col-md-12 justify-content-around mt-5"
                  style={{
                    padding: "0.75rem 1.25rem",
                    backgroundColor: "rgba(0,0,0,.03)",
                    borderTop: "0 solid rgba(0,0,0,.125)",
                  }}
                >
                  <button
                    type="button"
                    onClick={generarTalonarios}
                    disabled={inhabilitado}
                    className="col-md-4 btn btn-success btn-sm rounded-pill"
                  >
                    Generar Talonarios
                  </button>

                  <button
                    type="button"
                    onClick={blanquearExpendedor}
                    className="col-md-4 btn btn-danger btn-sm rounded-pill"
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
            <div className="col-md-6 border-table">
              <p className="h2 text-center">
                <strong>{"TALONARIOS ASIGNADOS"}</strong>
              </p>

              <div className="row col-md-10 py-5 mx-auto">
                <div className="col-md-12 p-2 mt-4">
                  <div className="row col-md-12 d-flex justify-content-between">
                    <input
                      type="text"
                      className=" col-2 form-control form-control-sm rounded-pill"
                      ref={txtBuscador}
                      onChange={handleSearch}
                      placeholder="Buscar"
                    />
                  </div>
                </div>
                <div className="col-md-12" style={{ margin: "auto" }}>
                  <TblContainer>
                    <TblHead />

                    <TableBody>
                      {records &&
                        recordsAfterPagingAndSorting().map((item, index) => (
                          <TableRow key={index} style={{ padding: "0" }}>
                            <TableCell style={{ textAlign: "center" }}>
                              {item.idtalonarioguia}
                            </TableCell>
                            <TableCell style={{ textAlign: "start" }}>
                              {item.nombre.trim()}
                            </TableCell>
                            <TableCell style={{ textAlign: "center" }}>
                              {item.desde}
                            </TableCell>
                            <TableCell style={{ textAlign: "center" }}>
                              {item.hasta}
                            </TableCell>
                            <TableCell style={{ textAlign: "center" }}>
                              {item.cantidad}
                            </TableCell>
                            <TableCell style={{ textAlign: "center" }}>
                              {moment(item.fechasistema).format("L")}
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </TblContainer>
                  <TblPagination />
                </div>

                <Mensaje
                  mensaje={mensaje}
                  onHide={() =>
                    setMensaje({
                      mostrar: false,
                      titulo: "",
                      texto: "",
                      icono: "",
                    })
                  }
                />
              </div>
            </div>
          </div>
        </div>

        <div
          className="tab-pane fade"
          id="ex-with-icons-tabs-2"
          role="tabpanel"
          aria-labelledby="ex-with-icons-tab-2"
        >
          <GuiasMovilizacionWeb />
        </div>
      </div>

      <CatalogoAgenteTipo2
        show={mostrarcatalogo}
        campoclave={"mina"}
        valorclave={true}
        onHideAceptaCatAge={seleccionarExpendedor}
        onHideCancelaCatAge={cerrarCatalogo}
      />
      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
}

export default GenerarGuiasMovilizacion;

/////////////#####$$$$$#####/////////////////
/////#####Generar Planillas#####/////////
/////#####Programador: Cesar Ratia#####/////
/////#####Empresa: Sygre.ca#####///////////
///////////#####$$$$$#####////////////////



// WEBPACK FOOTER //
// ./src/components/guiasmovilizacion/gestionarGuiasMovilizacion.js